"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _authorisation = _interopRequireDefault(require("./../../components/authorisation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var StateList = /*#__PURE__*/function (_React$Component) {
  _inherits(StateList, _React$Component);

  function StateList(props) {
    var _this;

    _classCallCheck(this, StateList);

    _this = _possibleConstructorReturn(this, (StateList.__proto__ || Object.getPrototypeOf(StateList)).call(this, props));
    _this.pvAndAdmin = new _authorisation.default(['admin', 'projectresponsible'], [props.projectKey], false);
    return _this;
  }

  _createClass(StateList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var rows = this.props.data.map(function (row, index) {
        var stateClassname = 'prefix',
            info1 = row.info1,
            info2 = row.info2,
            info3 = row.info3;
        stateClassname += row.state.color ? ' color-' + row.state.color : '';
        stateClassname += row.state.icon ? ' ' + row.state.icon : '';

        if ((row.type === 'project-state-data' || row.type === 'release-state-data') && typeof info1 === 'function') {
          var Info1 = _this2.pvAndAdmin(info1());

          return /*#__PURE__*/_react.default.createElement("tr", {
            key: index
          }, /*#__PURE__*/_react.default.createElement("td", {
            className: "small-text"
          }, /*#__PURE__*/_react.default.createElement("span", {
            className: stateClassname
          }, row.state.value || '')), /*#__PURE__*/_react.default.createElement("td", {
            className: "large-text"
          }, row.subject), /*#__PURE__*/_react.default.createElement("td", {
            className: "small-text"
          }, /*#__PURE__*/_react.default.createElement(Info1, null)), /*#__PURE__*/_react.default.createElement("td", {
            className: "small-text"
          }), /*#__PURE__*/_react.default.createElement("td", {
            className: "small-text"
          }));
        }

        if (typeof info1 !== 'function') info1 = function info1() {
          return /*#__PURE__*/_react.default.createElement("span", null, row.info1 && row.info1.icon ? /*#__PURE__*/_react.default.createElement("i", {
            className: row.info1.icon
          }) : null, row.info1 && row.info1.text ? row.info1.text : null);
        };
        if (typeof info2 !== 'function') info2 = function info2() {
          return /*#__PURE__*/_react.default.createElement("span", null, row.info2 && row.info2.icon ? /*#__PURE__*/_react.default.createElement("i", {
            className: row.info2.icon
          }) : null, row.info2 && row.info2.text ? row.info2.text : null);
        };
        if (typeof info3 !== 'function') info3 = function info3() {
          return /*#__PURE__*/_react.default.createElement("span", null, row.info3 && row.info3.icon ? /*#__PURE__*/_react.default.createElement("i", {
            className: row.info3.icon
          }) : null, row.info3 && row.info3.text ? row.info3.text : null);
        };

        var info3Element = /*#__PURE__*/_react.default.createElement("td", {
          className: "small-text"
        }, info3());

        if ((row.type === 'project-state-data' || row.type === 'release-state-data') && typeof info3 === 'function') {
          var Info3 = _this2.pvAndAdmin(info3());

          info3Element = /*#__PURE__*/_react.default.createElement("td", {
            className: "small-text"
          }, /*#__PURE__*/_react.default.createElement(Info3, null));
        }

        return /*#__PURE__*/_react.default.createElement("tr", {
          key: index
        }, /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement("span", {
          className: stateClassname
        }, row.state.value || '')), /*#__PURE__*/_react.default.createElement("td", {
          className: "large-text"
        }, row.subject), /*#__PURE__*/_react.default.createElement("td", {
          className: "small-text"
        }, info1()), /*#__PURE__*/_react.default.createElement("td", {
          className: "small-text"
        }, info2()), info3Element);
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "state-list"
      }, rows.length && !this.props.isLoading ? /*#__PURE__*/_react.default.createElement("table", {
        className: "state-list__table"
      }, /*#__PURE__*/_react.default.createElement("tbody", null, rows)) : null, rows.length === 0 && !this.props.isLoading ? /*#__PURE__*/_react.default.createElement("div", {
        className: "state-list__no-data"
      }, this.props.staticTexts.noData) : null, this.props.isLoading ? /*#__PURE__*/_react.default.createElement("div", {
        className: "state-list__loader"
      }, this.props.staticTexts.loading, /*#__PURE__*/_react.default.createElement("span", {
        className: "loader"
      })) : null);
    }
  }]);

  return StateList;
}(_react.default.Component);

StateList.propTypes = {
  projectKey: _propTypes.default.string.isRequired,
  data: _propTypes.default.array,
  isLoading: _propTypes.default.bool,
  staticTexts: _propTypes.default.object
};
var _default = StateList;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/state-list/index.js
// module id = 158
// module chunks = 0